export default __webpack_public_path__ + "static/N0287-05db69983d2836d7d75e1d0f8235f562.png";